import script from "./DeviceCalibrationV2CheckerboardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceCalibrationV2CheckerboardPage.vue?vue&type=script&setup=true&lang=js"

import "./DeviceCalibrationV2CheckerboardPage.vue?vue&type=style&index=0&id=19792966&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19792966"]])

export default __exports__